import axios from "axios"

export const getInvoicesProps = async ({date, rfc, webId, ticket}) => {
  const url = `${process.env.REACT_APP_URL}/invoices?date=${date}&rfc=${rfc}&invoiceKey=${webId}&folio=${ticket}&idBrand=${process.env.REACT_APP_ID_BRAND}&qid=${process.env.REACT_APP_QID}`
  const headers = { authorization: process.env.REACT_APP_TOKEN_TEST  }
  const data = await axios.get(url,  {headers}).then(resp => {

    const payments = resp.data.paymentTypes.map(payment => {
      return {
        value: payment.code,
        label: payment.description
      }
    })
    const regimes = resp.data.regimes.map(regime => {
      return {
        value: regime.code,
        label: regime.description
      }
    })

    const uses = resp.data.uses.map(use => {
      return {
        value: use.code,
        label: use.description
      }
    })
    const newResponse = {
      ...resp,
      data: {
        ...resp.data,
        paymentTypes: payments,
        regimes: regimes,
        uses: uses
      }
    }
    return newResponse
  }).catch(err => {
    return err.response.data
  })
  return data
}

export const postInvoice = async (form) => {
  const base = process.env.REACT_APP_URL
  const origin = process.env.REACT_APP_ORIGIN
  const url = `${base}/invoices/income?&qid=${process.env.REACT_APP_QID}&origin=${origin}`
  const headers = { authorization: process.env.REACT_APP_TOKEN_TEST  }
  const data = await axios.post(url, form, {headers}).then(resp => resp).catch(err => {
    return err.response.data
  })
  // const tempRegime = [{code: "621", description: "Incorporación Fiscal"}, { code: "605", description: 'Salarios e Ingresos Asimilados a Salarios' }, ...data.regimes]
  // const newData = {
  //   ...data,
  //   regimes: tempRegime
  // }
  return data
}
